import { FC } from "preact/compat";
import type { SidebarProps } from "./interfaces";
import AssignmentIcon from "@material-design-icons/svg/outlined/assignment.svg";
import { useSignal } from "@preact/signals";
import { format } from "date-fns";
import { Dropdown } from "~/components";

const KASE_USERS = [
    {
        id: "1",
        name: "Josephine",
    },
    {
        id: "2",
        name: "Phillip",
    },
];

const CLIENT_USERS = [
    {
        id: "1",
        name: "John Doe",
    },
    {
        id: "2",
        name: "Jane Doe",
    },
];

const toDatetime = (date: Date | string | null | undefined) =>
    date ? format(new Date(date), "yyyy-MM-dd HH:mm") : "";

const Sidebar: FC<SidebarProps> = ({ task }) => {
    const startDate = useSignal(toDatetime(task?.startDate));
    const endDate = useSignal(toDatetime(task?.endDate));
    const kase = useSignal<(typeof KASE_USERS)[number] | null>(null);
    const client = useSignal<(typeof CLIENT_USERS)[number] | null>(null);

    return (
        <div className="w-full [&_input]:bg-transparent">
            <div className="w-full p-2 mb-2">
                <h4 className="flex items-center px-2 mb-2 -mx-2">
                    <AssignmentIcon width="20" className="mr-2 fill-gray-500" />
                    <span className="text-sky-700">Details</span>
                </h4>
                <div className="p-3 border border-gray-200 rounded bg-gray-50">
                    <div className="grid items-center grid-cols-3 mt-2">
                        <div className="font-bold text-gray-500">Project</div>
                        <div className="col-span-2">
                            {task?.project?.name ? (
                                <span className="font-bold">
                                    {task?.project?.name}
                                </span>
                            ) : (
                                <span>-</span>
                            )}
                        </div>
                    </div>
                    <div className="grid items-center grid-cols-3 mt-2">
                        <div className="font-bold text-gray-500">Kase</div>
                        <div className="col-span-2">
                            <Dropdown
                                choices={KASE_USERS}
                                value={kase.value}
                                onChange={(value) => (kase.value = value)}
                                label="Select"
                            />
                        </div>
                    </div>

                    <div className="grid items-center grid-cols-3 mt-2">
                        <div className="font-bold text-gray-500">Client</div>
                        <div className="col-span-2">
                            <Dropdown
                                choices={CLIENT_USERS}
                                value={client.value}
                                onChange={(value) => (client.value = value)}
                                label="Select"
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-3 mt-2">
                        <div className="font-bold text-gray-500">
                            Start date
                        </div>
                        <div className="col-span-2">
                            <input
                                className="w-full text-gray-600 rounded outline-none focus:ring focus:ring-sky-500"
                                type="datetime-local"
                                value={startDate.value}
                                onChange={({ currentTarget }) =>
                                    (endDate.value = currentTarget.value)
                                }
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-3 mt-2">
                        <div className="font-bold text-gray-500">End date</div>
                        <div className="col-span-2">
                            <input
                                className="w-full text-gray-600 rounded outline-none focus:ring focus:ring-sky-500"
                                type="datetime-local"
                                value={endDate.value}
                                onChange={({ currentTarget }) =>
                                    (endDate.value = currentTarget.value)
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
